import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30ce0683"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-form__title" }, "Вход или регистрация", -1))
const _hoisted_3 = { class: "auth-form__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneForm = _resolveComponent("PhoneForm")!
  const _component_CodeForm = _resolveComponent("CodeForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.step === _ctx.PHONE_STEP)
        ? (_openBlock(), _createBlock(_component_PhoneForm, {
            key: 0,
            ref: "phoneForm",
            "error-message": _ctx.phoneStepErrorMessage,
            "redirect-route": _ctx.authStore.redirectRoute,
            "captcha-error": _ctx.captchaError,
            "is-visible-captcha": _ctx.isVisibleCaptcha,
            "current-phone": _ctx.phone,
            onClearError: _ctx.clearErrorCaptcha,
            onSend: _ctx.sendCode
          }, null, 8, ["error-message", "redirect-route", "captcha-error", "is-visible-captcha", "current-phone", "onClearError", "onSend"]))
        : _createCommentVNode("", true),
      (_ctx.step === _ctx.CODE_STEP)
        ? (_openBlock(), _createBlock(_component_CodeForm, {
            key: 1,
            "error-message": _ctx.codeStepErrorMessage,
            "is-registration": _ctx.isRegistration,
            "allow-send-at": _ctx.allowSendAt,
            phone: _ctx.phone,
            "is-loading": _ctx.authStore.isLoading,
            onConfirm: _ctx.validateCode,
            onSendNewCode: _ctx.sendNewCode,
            onChangePhone: _ctx.goToFirstStep
          }, null, 8, ["error-message", "is-registration", "allow-send-at", "phone", "is-loading", "onConfirm", "onSendNewCode", "onChangePhone"]))
        : _createCommentVNode("", true)
    ])
  ]))
}